import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import errorMessages from "Payments/AddPaymentMethod/CreditCardEntry/errorMessages";
import { AnimatePresence, motion } from "framer-motion";

const availableTitles = ["Oops!", "Oh no!", "Hmmm..."];
const defaultMsg =
  "Hmm... it looks like something went wrong. If the problem persists, please contact help@flocknote.com.";

export default function CardErrors({ inputErrors = [] }) {
  const [previousNumberOfErrors, setPreviousNumberOfErrors] = useState(
    inputErrors.length
  );

  const [title, setTitle] = useState(availableTitles[0]);

  useEffect(() => {
    setPreviousNumberOfErrors(inputErrors.length);

    if (inputErrors.length === 0) {
      setTitle(
        availableTitles[Math.floor(Math.random() * availableTitles.length)]
      );
    }
  }, [inputErrors.length]);

  return (
    <AnimatePresence>
      {inputErrors.length > 0 && (
        <Wrapper
          key="message"
          initial={{ height: 0, opacity: 0, y: -60 }}
          animate={{ height: "auto", opacity: 1, y: 0 }}
          exit={{
            height: 0,
            opacity: 0,
            y: -60,
            transition: { type: "tween" },
          }}
        >
          <MessageContainer>
            <AnimatePresence>
              <Title>
                <TitleIcon className="far fa-exclamation-circle" />
                {title}
              </Title>
              {inputErrors.map((errorType, index) => (
                <Message
                  key={errorType}
                  initial={
                    previousNumberOfErrors > 0
                      ? { opacity: 0, height: 0, y: 22 }
                      : { opacity: 1, height: "auto", y: 0 }
                  }
                  animate={{ opacity: 1, height: "auto", y: 0 }}
                  exit={{
                    opacity: 0,
                    height: 0,
                    y: index === 0 ? -22 : 22,
                    transition: { type: "tween" },
                  }}
                >
                  <MessageInside>
                    {errorMessages.find(
                      (errorInfo) => errorInfo.type === errorType
                    )?.message || defaultMsg}
                  </MessageInside>
                </Message>
              ))}
            </AnimatePresence>
          </MessageContainer>
          <Padding />
        </Wrapper>
      )}
    </AnimatePresence>
  );
}

const Wrapper = styled(motion.div)`
  position: relative;
  z-index: 1;
`;
const Padding = styled.div`
  height: 10px;
`;
const MessageContainer = styled.div`
  background: #f7f0b6;
  color: #d5a223;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.1em;
  padding: 8px 16px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: inset rgba(0, 0, 0, 0.3) 0 1px 5px;
`;

const Message = styled(motion.div)`
  overflow: hidden;
  margin-top: -1px;
`;
const MessageInside = styled.div`
  padding: 8px 0;
  padding-bottom: 9px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
  padding-top: 8px;
  padding-bottom: 8px;
`;

const TitleIcon = styled.div`
  margin-right: 12px;
`;
